import contextJson from '../context.json';
import localContextJson from '../context.local.json';

/** True only when context.local.json opts in (serve-with-local-api sets this for the session). */
export function isLocalApiUrlOverrideEnabled(): boolean {
  if (contextJson.dev?.useLocalApiUrlOverride === true) {
    console.warn(
      'context.json dev.useLocalApiUrlOverride is true — keep this false in git; use context.local.json for local stacks.'
    );
    return true;
  }
  return localContextJson.dev?.useLocalApiUrlOverride === true;
}
